module.exports = __webpack_public_path__ + "static/media/java.b48c6193.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/java.svg
// module id = 61
// module chunks = 0